import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import { IPagedResults } from 'src/app/core/models/base';
import { IEmployeCreateResponse, IEmployee, IEmployeeCreateRequest, IEmployeeRequest, IListEmployeesRequest, IUpdateEmployeeResponse } from '../employee';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }

  getEmployeeDetails(){
    return this.http.get<IEmployee>(
      `${environment.baseUrl}/v1/employee/getemployeedetails`
    )
  }

  getEmployee(id : string){
    return this.http.get<IEmployee>(
      `${environment.baseUrl}/v1/employee/getemployee/${id}`
    )
  }

  listEmployees(request: IListEmployeesRequest){
    return this.http.post<IPagedResults<IEmployee[]>>(
      `${environment.baseUrl}/v1/employee/searchemployees`,
      request
    )
  }

  createEmployee(request : IEmployeeCreateRequest){
    return this.http.post<IEmployeCreateResponse>(
      `${environment.baseUrl}/v1/employee/createemployee`,
      request
    )
  }

  updateEmployee(request : IEmployeeRequest){
    return this.http.put<IUpdateEmployeeResponse>(
      `${environment.baseUrl}/v1/employee/updateemployee/${request.id}`,
      request
    )
  }

  deleteEmployee(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/employee/deleteemployee/${id}`
    )
  }

  recalculateEmployees(){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/employee/recalculateemployees`,
      null
    )
  }
}
